import React, { useEffect, useState } from "react";
import "./index.scoped.css";
import CasinoVideo from "./components/CasinoVideo";
import Timer from "./components/Timer";
import { useDispatch } from "react-redux";
import { useQuery } from "react-query";
import {
  getCasinoBetsAPI,
  getCasinoExposureAPI,
  getCasinoLastTenResultAPI,
  getCasinoOddsAPI,
} from "../../service/casino";
import {
  CARD_ARRAY,
  CASINO_VIDEO,
  getCasinoPlExposureByRunner,
  getOddForEntity,
  setBet,
} from "./CasinoGeneric";
import { useLocation } from "react-router-dom";
import PlaceBet from "./components/PlaceBet";
import PlacedBet from "./components/PlacedBet";
import CasinoPage from "./components/CasinoPage";

export default function QueenTopTeenPatti() {
  const location = useLocation();
  var GAME_ID = location.pathname.split("/");
  GAME_ID = GAME_ID[GAME_ID.length - 1];
  // const VIDEO_ID = 3056;
   const VIDEO_ID = "teen41"
  const dispatch = useDispatch();
  const [showRules, setShowRules] = React.useState(false);
  const casinoData = useQuery(
    "getCasinoOdds",
    () => getCasinoOddsAPI(GAME_ID),
    {
      refetchInterval: 800,
    }
  );
  // const lastTenResultData = useQuery(
  //   "getResult",
  //   () => getCasinoLastTenResultAPI(GAME_ID),
  //   {
  //     refetchInterval: 1500,
  //   }
  // );
  // const casinoBets = useQuery("casinoBets", () => getCasinoBetsAPI(GAME_ID), {
  //   refetchInterval: 2500,
  // });
  // const [casinoPlData, setCasinoPlData] = useState([]);
  // const getPlExposure = async () => {
  //   const { response } = await getCasinoExposureAPI(
  //     casinoData?.data?.response?.marketId
  //   );
  //   setCasinoPlData(response);
  // };
  useEffect(() => {
    if (casinoData?.data?.response?.marketId) {
      let interval = setInterval(() => {
        // getPlExposure();
      }, 2000);
      return () => {
        clearInterval(interval);
      };
    }
  }, [casinoData?.data?.response?.marketId]);
  const [selectedTab, setSelectedTab] = React.useState("game");

  return (
    <div className="center-main-container casino-page">
      <div className="center-container">
        <div className="casino-page-container teenpatti2">
          <div className="casino-header">
            <span className="casino-name">
              Queen Top Open Teenpatti
              <a className="ms-1">
                <small>Rules</small>
              </a>
            </span>
            <span className="casino-rid d-none d-xl-inline-block">
              <small>
                Round ID: <span>159250424213540</span>
              </small>
            </span>
          </div>
          <div className="casino-title-header-mobile d-xl-none">
            <ul className="nav nav-tabs menu-tabs">
              <li className="nav-item">
                <div className="nav-link active">Game</div>
              </li>
              <li className="nav-item">
                <div className="nav-link">Placed Bet (0)</div>
              </li>
            </ul>
            <div className="pe-2">
              <span className="casino-rid">
                Round ID: <span>159250424213540</span>
              </span>
            </div>
          </div>
          <div className="">
            <div className="casino-video">
              <div className="video-box-container">
                <div className="casino-video-box">
                  {/* <iframe src="/mediaplayer/teen41/d4c070dc-d790-4f5f-8cd9-b423789b576c?ip=122.160.119.41" /> */}
                </div>
              </div>
              <div className="casino-video-cards">
                <div className="">
                  <h5>Player A</h5>
                  <div className="flip-card-container">
                    <div className="flip-card">
                      <div className="flip-card-inner ">
                        <div className="flip-card-front">
                          <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/QSS.jpg" />
                        </div>
                        <div className="flip-card-back">
                          <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/QSS.jpg" />
                        </div>
                      </div>
                    </div>
                    <div className="flip-card">
                      <div className="flip-card-inner ">
                        <div className="flip-card-front">
                          <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/JHH.jpg" />
                        </div>
                        <div className="flip-card-back">
                          <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/JHH.jpg" />
                        </div>
                      </div>
                    </div>
                    <div className="flip-card">
                      <div className="flip-card-inner ">
                        <div className="flip-card-front">
                          <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/9DD.jpg" />
                        </div>
                        <div className="flip-card-back">
                          <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/9DD.jpg" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="mt-1">
                  <h5>Player B</h5>
                  <div className="flip-card-container">
                    <div className="flip-card">
                      <div className="flip-card-inner ">
                        <div className="flip-card-front">
                          <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/1.jpg" />
                        </div>
                        <div className="flip-card-back">
                          <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/1.jpg" />
                        </div>
                      </div>
                    </div>
                    <div className="flip-card">
                      <div className="flip-card-inner ">
                        <div className="flip-card-front">
                          <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/1.jpg" />
                        </div>
                        <div className="flip-card-back">
                          <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/1.jpg" />
                        </div>
                      </div>
                    </div>
                    <div className="flip-card">
                      <div className="flip-card-inner ">
                        <div className="flip-card-front">
                          <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/1.jpg" />
                        </div>
                        <div className="flip-card-back">
                          <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/1.jpg" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* <div className="clock flip-clock-wrapper">
              <ul className="flip play">
                <li className="flip-clock-before">
                  <a href="#">
                    <div className="up">
                      <div className="shadow" />
                      <div className="inn">2</div>
                    </div>
                    <div className="down">
                      <div className="shadow" />
                      <div className="inn">2</div>
                    </div>
                  </a>
                </li>
                <li className="flip-clock-active">
                  <a href="#">
                    <div className="up">
                      <div className="shadow" />
                      <div className="inn">1</div>
                    </div>
                    <div className="down">
                      <div className="shadow" />
                      <div className="inn">1</div>
                    </div>
                  </a>
                </li>
              </ul>
              <ul className="flip play">
                <li className="flip-clock-before">
                  <a href="#">
                    <div className="up">
                      <div className="shadow" />
                      <div className="inn">6</div>
                    </div>
                    <div className="down">
                      <div className="shadow" />
                      <div className="inn">6</div>
                    </div>
                  </a>
                </li>
                <li className="flip-clock-active">
                  <a href="#">
                    <div className="up">
                      <div className="shadow" />
                      <div className="inn">5</div>
                    </div>
                    <div className="down">
                      <div className="shadow" />
                      <div className="inn">5</div>
                    </div>
                  </a>
                </li>
              </ul>
            </div> */}
            </div>
            <div className="casino-detail">
              <div className="casino-table">
                <div className="casino-table-box">
                  <div className="casino-table-left-box">
                    <div className="casino-table-header">
                      <div className="casino-nation-detail">Player A</div>
                      <div className="casino-odds-box back">Back</div>
                      <div className="casino-odds-box lay">Lay</div>
                    </div>
                    <div className="casino-table-body">
                      <div className="casino-table-row ">
                        <div className="casino-nation-detail">
                          <div className="casino-nation-name">Main</div>
                        </div>
                        <div className="casino-odds-box back suspended-box">
                          <span className="casino-odds">0</span>
                        </div>
                        <div className="casino-odds-box lay suspended-box">
                          <span className="casino-odds">0</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="casino-table-box-divider" />
                  <div className="casino-table-right-box">
                    <div className="casino-table-header">
                      <div className="casino-nation-detail">Player B</div>
                      <div className="casino-odds-box back">Back</div>
                      <div className="casino-odds-box lay">Lay</div>
                    </div>
                    <div className="casino-table-body">
                      <div className="casino-table-row">
                        <div className="casino-nation-detail">
                          <div className="casino-nation-name">Main</div>
                        </div>
                        <div className="casino-odds-box back">
                          <span className="casino-odds">1.6</span>
                        </div>
                        <div className="casino-odds-box lay">
                          <span className="casino-odds">1.63</span>
                        </div>
                      </div>
                      <div className="casino-table-row under-over-row">
                        <div className="uo-box">
                          <div className="casino-nation-detail">
                            <div className="casino-nation-name">
                              Player B Under 21
                            </div>
                          </div>
                          <div className="casino-odds-box back">
                            <span className="casino-odds">2.61</span>
                          </div>
                        </div>
                        <div className="uo-box">
                          <div className="casino-nation-detail">
                            <div className="casino-nation-name">
                              Player B Over 21
                            </div>
                          </div>
                          <div className="casino-odds-box back">
                            <span className="casino-odds">1.62</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="casino-last-result-title">
                <span>Last Result</span>
                <span>
                  <a href="/casino-results/teen41">View All</a>
                </span>
              </div>
              <div className="casino-last-results">
                <span className="result result-b">B</span>
                <span className="result result-a">A</span>
                <span className="result result-b">B</span>
                <span className="result result-b">B</span>
                <span className="result result-b">B</span>
                <span className="result result-b">B</span>
                <span className="result result-b">B</span>
                <span className="result result-a">A</span>
                <span className="result result-b">B</span>
                <span className="result result-b">B</span>
              </div>
            </div>
          </div>
          <div className="d-none">
            <div className="table-responsive">
              <table className="table">
                <thead>
                  <tr>
                    <th>Matched Bet</th>
                    <th className="text-end">Odds</th>
                    <th className="text-end">Stake</th>
                  </tr>
                </thead>
                <tbody />
              </table>
            </div>
          </div>
        </div>
      </div>
      <div className="sidebar right-sidebar casino-right-sidebar sticky">
        <div className="sidebar-box my-bet-container">
          <div className="sidebar-title">
            <h4>My Bet</h4>
          </div>
          <div className="my-bets">
            <div className="table-responsive">
              <table className="table">
                <thead>
                  <tr>
                    <th>Matched Bet</th>
                    <th className="text-end">Odds</th>
                    <th className="text-end">Stake</th>
                  </tr>
                </thead>
                <tbody />
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
